<template>
  <section class="filters panel">
    <div class="filter-header">
      <div>
        <h2>Filters</h2>
        <p>Loads all-time by default. Set a date range here, or open advanced filters for segment drilldowns.</p>
      </div>
      <button type="button" class="ghost-button" @click="$emit('reset')">Reset</button>
    </div>

    <div class="filter-grid">
      <label>
        <span>Start month</span>
        <input v-model="filters.startMonth" type="month" :min="minMonth" :max="maxMonth">
      </label>
      <label>
        <span>End month</span>
        <input v-model="filters.endMonth" type="month" :min="minMonth" :max="maxMonth">
      </label>
    </div>

    <details class="advanced-filters">
      <summary>Advanced filters</summary>
      <div class="filter-grid select-grid">
        <label>
          <span>Job level</span>
          <select v-model="filters.levels" multiple>
            <option v-for="option in levels" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Contract</span>
          <select v-model="filters.contracts" multiple>
            <option v-for="option in contracts" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Salary</span>
          <select v-model="filters.salaryPresence">
            <option value="all">Any salary state</option>
            <option value="present">Salary present</option>
            <option value="parsed">Parsed salary only</option>
            <option value="missing">Salary missing</option>
          </select>
        </label>
        <label>
          <span>Parent category</span>
          <select v-model="filters.parentCategories" multiple>
            <option v-for="option in parentCategories" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Child tags</span>
          <select v-model="filters.childTags" multiple>
            <option v-for="option in childTags" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Country / remote</span>
          <select v-model="filters.geos" multiple>
            <option v-for="option in geos" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Application type</span>
          <select v-model="filters.applicationTypes" multiple>
            <option value="url">URL</option>
            <option value="email">Email</option>
            <option value="unknown">Unknown</option>
          </select>
        </label>
        <label>
          <span>ATS provider</span>
          <select v-model="filters.providers" multiple>
            <option v-for="option in providers" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Raw host</span>
          <select v-model="filters.hosts" multiple>
            <option v-for="option in hosts" :key="option.id" :value="option.id">{{ option.title }}</option>
          </select>
        </label>
        <label>
          <span>Salary currency</span>
          <select v-model="filters.salaryCurrencies" multiple>
            <option value="USD">USD</option>
            <option value="GBP">GBP</option>
            <option value="EUR">EUR</option>
            <option value="CAD">CAD</option>
          </select>
        </label>
        <label>
          <span>Salary period</span>
          <select v-model="filters.salaryPeriods" multiple>
            <option value="year">Year</option>
            <option value="hour">Hour</option>
            <option value="month">Month</option>
          </select>
        </label>
      </div>
    </details>
  </section>
</template>

<script setup>
defineProps({
  filters: { type: Object, required: true },
  minMonth: { type: String, default: '' },
  maxMonth: { type: String, default: '' },
  levels: { type: Array, default: () => [] },
  contracts: { type: Array, default: () => [] },
  parentCategories: { type: Array, default: () => [] },
  childTags: { type: Array, default: () => [] },
  geos: { type: Array, default: () => [] },
  providers: { type: Array, default: () => [] },
  hosts: { type: Array, default: () => [] }
});

defineEmits(['reset']);
</script>
